import { isArrayEmpty, sortDates } from "../omnia"
import { ImageryDate, SatImageType } from "./types"

export class ImageryDay {


    public readonly date: Date

    public readonly layers: number

    public firstDayOfYear = false
    public prevOffset = 0
    public label: string
    public marginLeft = 0
    public icons: string[]
    public rgbOnly = false

    constructor(date: ImageryDate) {
        this.date = date.date
        this.layers = date.layers
    }


}

export function setupDays(dates: (ImageryDate & { rgbOnly: boolean })[]) {

    const days = dates
        .reduce((days, date) => {

            const prev = days[days.length - 1]

            const day = new ImageryDay(date)
            const d = date.date

            if (prev) {
                day.prevOffset = (d.valueOf() - prev.date.valueOf()) / (24 * 60 * 60 * 1000)
                day.firstDayOfYear = (prev.date.getFullYear() != d.getFullYear())
            }
            else {
                day.firstDayOfYear = true
            }

            day.label = day.firstDayOfYear
                ? d.toLocaleDateString(undefined, { year: "numeric", month: "2-digit", day: "2-digit" })
                : d.toLocaleDateString(undefined, { month: "2-digit", day: "2-digit" })

            day.marginLeft = Math.round(5 * day.prevOffset)

            day.rgbOnly = date.rgbOnly

            day.icons = [

                date.rgbOnly
                    ? "fa-solid fa-cloud"
                    : undefined,

                date.layers
                    ? "fas fa-layer-group"
                    : undefined,

                date.layerTasksPending && (!date.layerTasksRunning)
                    ? "far fa-clock"
                    : undefined,

                date.layerTasksRunning
                    ? "fas fa-cog animate-spin"
                    : undefined


            ].filter(i => !!i)

            days.push(day)

            return days

        }, [] as ImageryDay[])

    const sorted = days.sort((a, b) => sortDates(a.date, b.date))

    return sorted

}

/**
 * Returns the first day that will be displayed when opening the module
 * This will be the latest available day
 * Assumes that the array is already sorted in ascending date order
 * @param days Days
 */
export function getDefaultDay(days: ImageryDay[]) {
    if (!isArrayEmpty(days)) {
        return days[days.length - 1]
    }
}

export function isRgb(type: SatImageType) {
    return ((type === SatImageType.RGB) || (type === SatImageType.PlanetRGB))
}
